import { gql } from "apollo-boost";

export const SET_FF_VARINAT_ID = gql`
  mutation SetFFVariantID($ccId: ID, $dsId: ID, $orderId: ID!) {
    setFFVariantID(ccId: $ccId, dsId: $dsId, orderId: $orderId)
  }
`;
